import { ENV } from '@/src/.env';

export class Navigator {
  static redirectToLogin(): void {
    const redirect = encodeURIComponent(window.location.href);
    window.location.href = `${ENV.IDENTITY_URL}/login?redirect=${redirect}`;
  }
}
